// Seal Subscription Cancellation Flow
// Custom retention system with progressive offers

document.addEventListener("DOMContentLoaded", function () {
  // --- Modal and Button Elements ---
  var unsubscribeBtn = document.getElementById("seal-unsubscribe-button");
  var modal = document.getElementById("custom-unsubscribe-modal");
  var freeGiftModal = document.getElementById("free-gift-modal");
  var fiftyOffModal = document.getElementById("fifty-off-modal");
  var fiftyOffSuccessModal = document.getElementById("fifty-off-success-modal");
  var cancelledModal = document.getElementById("cancelled-modal");
  var skipSuccessModal = document.getElementById("skip-success-modal");
  var giftSuccessModal = document.getElementById("gift-success-modal");

  var closeBtns = document.querySelectorAll(".custom-modal-close");
  var skipBtn = modal ? modal.querySelector(".custom-modal-action-skip") : null;
  var freeGiftBtn = freeGiftModal
    ? freeGiftModal.querySelector(".custom-modal-action-gift")
    : null;
  var freeGiftCancelLink = freeGiftModal
    ? freeGiftModal.querySelector(".custom-modal-cancel-link")
    : null;
  var cancelLinks = modal
    ? modal.querySelectorAll(".custom-modal-cancel-link")
    : [];
  var fiftyOffBtn = fiftyOffModal
    ? fiftyOffModal.querySelector(".custom-modal-action-50off")
    : null;
  var fiftyOffCancelBtn = fiftyOffModal
    ? fiftyOffModal.querySelector(".custom-modal-cancel-link-50off")
    : null;
  var closeSuccessBtn = fiftyOffSuccessModal
    ? fiftyOffSuccessModal.querySelector(".close-success-modal")
    : null;
  var closeCancelledBtn = cancelledModal
    ? cancelledModal.querySelector(".close-cancelled-modal")
    : null;
  var closeSkipSuccessBtn = skipSuccessModal
    ? skipSuccessModal.querySelector(".close-skip-success-modal")
    : null;
  var closeGiftSuccessBtn = giftSuccessModal
    ? giftSuccessModal.querySelector(".close-gift-success-modal")
    : null;

  // --- Utility Functions ---
  function showModal(modal) {
    if (modal) modal.style.display = "flex";
  }
  function hideModal(modal) {
    if (modal) modal.style.display = "none";
  }
  function getInternalId() {
    var sealSubIdElem = document.querySelector(
      ".seal-oneThird.seal-tar.seal-subdued.seal-sub-id"
    );
    return sealSubIdElem
      ? sealSubIdElem.textContent.replace("#", "").trim()
      : null;
  }
  function getCustomerEmail() {
    return (window as any).CUSTOMER_EMAIL;
  }

  // --- Modal Close Logic ---
  closeBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      hideModal(btn.closest(".custom-modal"));
    });
  });
  if (closeSuccessBtn) {
    closeSuccessBtn.addEventListener("click", function () {
      hideModal(fiftyOffSuccessModal);
      window.location.reload();
    });
  }
  if (closeCancelledBtn) {
    closeCancelledBtn.addEventListener("click", function () {
      hideModal(cancelledModal);
      window.location.reload();
    });
  }

  // --- Unsubscribe Modal Logic ---
  if (unsubscribeBtn && modal) {
    unsubscribeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showModal(modal);
    });
  }

  // --- Free Gift Modal Logic ---
  if (freeGiftBtn) {
    freeGiftBtn.addEventListener("click", async function () {
      try {
        freeGiftBtn.classList.add("loading");
        const subject = encodeURIComponent(
          "Claim My Free Subscription Gift / Don't Cancel"
        );
        const body = encodeURIComponent(
          "Hi Filterbaby! I need assistance claiming my free gift with my next subscription."
        );
        const emailLink = `mailto:help@filterbaby.com?subject=${subject}&body=${body}`;
        window.open(emailLink, "_blank");

        var customerEmail = getCustomerEmail();
        var sealSubInternalId = getInternalId();
        await fetch(
          "https://filterbaby-seal-backend.fly.dev/api/subscription/reschedule",
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              customerEmail: customerEmail,
              internalId: sealSubInternalId,
              customerId: (window as any).CUSTOMER_ID,
            }),
          }
        );
        hideModal(freeGiftModal);
        showModal(giftSuccessModal);
      } catch (err) {
        alert("There was an error processing your request.");
      } finally {
        freeGiftBtn.classList.remove("loading");
      }
    });
  }
  // Free Gift "No thank you" shows 50% off modal
  if (freeGiftCancelLink && fiftyOffModal) {
    freeGiftCancelLink.addEventListener("click", function (e) {
      e.preventDefault();
      hideModal(freeGiftModal);
      // Check if customer has the discount50 tag
      if (
        (window as any).CUSTOMER_TAGS &&
        (window as any).CUSTOMER_TAGS.includes("cancel-button-mitigation-discount50")
      ) {
        // If they have the tag, show cancelled modal directly
        showModal(cancelledModal);
      } else {
        // If they don't have the tag, show 50% off modal
        showModal(fiftyOffModal);
      }
    });
  }

  // --- Cancel Link in Unsubscribe Modal shows Free Gift Modal ---
  if (cancelLinks.length && freeGiftModal) {
    cancelLinks.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        hideModal(modal);
        showModal(freeGiftModal);
      });
    });
  }

  // --- Skip My Next Refill Logic ---
  if (skipBtn) {
    skipBtn.addEventListener("click", async function (e) {
      e.preventDefault();
      var customerEmail = getCustomerEmail();
      var sealSubInternalId = getInternalId();
      try {
        skipBtn.classList.add("loading");
        const response = await fetch(
          "https://filterbaby-seal-backend.fly.dev/api/subscription/skip",
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              customerEmail: customerEmail,
              internalId: sealSubInternalId,
              customerId: (window as any).CUSTOMER_ID,
            }),
          }
        );
        const data = await response.json();
        if (data.success) {
          hideModal(modal);
          showModal(skipSuccessModal);
        } else {
          hideModal(modal);
          showModal(freeGiftModal);
        }
      } catch (err) {
        alert("There was an error processing your request.");
      } finally {
        skipBtn.classList.remove("loading");
      }
    });
  }

  // --- 50% Off Modal Logic ---
  if (fiftyOffBtn) {
    fiftyOffBtn.addEventListener("click", async function (e) {
      e.preventDefault();
      var customerEmail = getCustomerEmail();
      var sealSubInternalId = getInternalId();
      try {
        fiftyOffBtn.classList.add("loading");
        await fetch(
          "https://filterbaby-seal-backend.fly.dev/api/subscription/discount",
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              customerEmail: customerEmail,
              internalId: sealSubInternalId,
              customerId: (window as any).CUSTOMER_ID,
            }),
          }
        );
        hideModal(fiftyOffModal);
        showModal(fiftyOffSuccessModal);
      } catch (err) {
        alert("There was an error applying your discount.");
      } finally {
        fiftyOffBtn.classList.remove("loading");
      }
    });
  }
  if (fiftyOffCancelBtn) {
    fiftyOffCancelBtn.addEventListener("click", async function (e) {
      e.preventDefault();
      var customerEmail = getCustomerEmail();
      var sealSubInternalId = getInternalId();
      try {
        fiftyOffCancelBtn.classList.add("loading");
        await fetch(
          "https://filterbaby-seal-backend.fly.dev/api/subscription/cancel",
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              customerEmail: customerEmail,
              customerId: (window as any).CUSTOMER_ID,
              internalId: sealSubInternalId,
            }),
          }
        );
        hideModal(fiftyOffModal);
        showModal(cancelledModal);
      } catch (err) {
        alert("There was an error cancelling your subscription.");
      } finally {
        fiftyOffCancelBtn.classList.remove("loading");
      }
    });
  }

  if (closeSkipSuccessBtn) {
    closeSkipSuccessBtn.addEventListener("click", function () {
      hideModal(skipSuccessModal);
      window.location.reload();
    });
  }
  if (closeGiftSuccessBtn) {
    closeGiftSuccessBtn.addEventListener("click", function () {
      hideModal(giftSuccessModal);
      window.location.reload();
    });
  }
});